import React from 'react'
import { BANKING_BOTTOM_CONTENT, SOFTWARE_COURSE_PAGE_6, SOFTWARE_DETAILS_PAGE_6, SOFTWARE_HERO_PAGE_6 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { SOFTWARE_ACCORDIAN_6 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const SoftwarePage_6 = () => {
  return (
    <div className='outlet-render'>
        <CourseAsideHero  {...SOFTWARE_HERO_PAGE_6}/>
     <CoursesAside {...SOFTWARE_COURSE_PAGE_6}/>
     <CourseCard {...SOFTWARE_DETAILS_PAGE_6}/>
     <Accordian {...SOFTWARE_ACCORDIAN_6}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default SoftwarePage_6